import * as React from 'react';
import {MIXPANEL_TOKEN, API, USER_ID, INSTITUTION, WHITE_LABEL, WHITE_LABEL_ID} from '../config';
import {EXPERIMENTS} from '../experiments';
import {BaseTracker, TrackFunction} from './base-tracker';
import {MixpanelTracker} from './mixpanel-tracker';
import memoize = require('lodash/memoize');

const tracker = MIXPANEL_TOKEN
  ? new MixpanelTracker(MIXPANEL_TOKEN, API, USER_ID, EXPERIMENTS)
  : new BaseTracker();

export function track(event: string, data: object = {}, fn?: () => void): void {
  const args = INSTITUTION && INSTITUTION.key
    ? {...data, institution: INSTITUTION.key}
    : data;

  tracker.track(event, args, fn);
}

export function getDistinctId(): string {
  return tracker.getDistinctId();
}

export const trackOnce: TrackFunction = memoize(track);

export const trackToParent = (screen: string, field?: string, field_value?: any): void => {
  if (WHITE_LABEL === 'green') {
    window.parent.postMessage({
      messageType: 'event',
      screen_view_type: screen,
      pramp_contact_id: WHITE_LABEL_ID,
      name: !!field ? 'interaction' : 'screen_view',
      field, field_value,
    }, '*');
  }
};

export interface ITrackerProps {
  trackOnce: TrackFunction;
  track: TrackFunction;
}

export function connectTracker<P>(WrappedComponent: any): React.ComponentClass<P> {
  return class extends React.Component<P, any> {
    public render(): React.ReactElement<P> {
      return (
        <WrappedComponent
          {...(this as any).props}
          trackOnce={trackOnce}
          track={track}
        />
      );
    }
  };
}
